import React, { useEffect, useMemo, useState } from "react";

const OWNER_LOGO_BASE =
  "https://semdoc-public-resources.s3.ap-south-1.amazonaws.com/energyband-public-resources/owner-assets/";

function ownerLogoUrlFromId(id) {
  if (id == null) return null;
  const s = String(id).trim();
  if (!s) return null;
  return `${OWNER_LOGO_BASE}owner_${s}.jpeg`;
}

function resolveOwnerId(propId) {
  if (propId != null && String(propId).trim() !== "") return String(propId).trim();
  try {
    const fromStore = localStorage.getItem("energyband_owner_id");
    return fromStore && String(fromStore).trim() !== "" ? String(fromStore).trim() : null;
  } catch {
    return null;
  }
}

function ownerDisplayNameFromStorage() {
  try {
    const raw = localStorage.getItem("energyband_owner_info");
    if (!raw) return "Owner";
    const o = JSON.parse(raw);
    return (
      o.name ||
      o.full_name ||
      o.provider_name ||
      o.display_name ||
      o.phone ||
      "Owner"
    );
  } catch {
    return "Owner";
  }
}

/**
 * Lightweight stand-in for rpm-dashboard Header on the RPM patient list page
 * (no MUI / FontAwesome / notifications bundle).
 */
function RpmListHeader({ pageTitle, ownerName, ownerId, onLogout }) {
  const displayName = ownerName ?? ownerDisplayNameFromStorage();
  const resolvedOwnerId = useMemo(() => resolveOwnerId(ownerId), [ownerId]);
  const ownerLogoUrl = useMemo(
    () => ownerLogoUrlFromId(resolvedOwnerId),
    [resolvedOwnerId]
  );
  const [ownerLogoFailed, setOwnerLogoFailed] = useState(false);

  useEffect(() => {
    setOwnerLogoFailed(false);
  }, [ownerLogoUrl]);

  return (
    <header className="rpm-list-header">
      <div className="rpm-list-header-inner">
        <div className="rpm-list-header-left">
          <div className="rpm-list-header-title">{pageTitle}</div>
        </div>
        <div className="rpm-list-header-center">
          {ownerLogoUrl && !ownerLogoFailed ? (
            <img
              src={ownerLogoUrl}
              alt=""
              className="rpm-list-header-owner-logo"
              onError={() => setOwnerLogoFailed(true)}
            />
          ) : null}
        </div>
        <div className="rpm-list-header-right">
          <div className="rpm-list-header-actions">
            <div className="rpm-list-header-profile">
              <span className="rpm-list-header-name">{displayName}</span>
            </div>
            {typeof onLogout === "function" ? (
              <button
                type="button"
                className="rpm-list-header-logout"
                onClick={onLogout}
              >
                Logout
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </header>
  );
}

export default RpmListHeader;
